import React from 'react'
import { DateInput, NullableBooleanInput, Filter, ReferenceInput, AutocompleteInput, SelectArrayInput, NumberInput, TextInput } from 'react-admin'

export const IntegrationFilters = ({ showUpdatedAtGte, showIncomplete, showEntityTypeId, showEndpoint, showIntegration, showDevelopment, showModuleConfiguration, showHasEntities, showStatusTypeId, showExternalCompanyNumber, showName, ...props }) => {
    const wildCardSearchName = (searchText) => ({name: {searchText: searchText, operation: "lk"}});
    return (
    <Filter {...props}>
            {showIntegration && <ReferenceInput filterToQuery={ wildCardSearchName } sort={{ field: 'name', order: 'ASC' }} perPage={100} label="Integration" source="integrationId" reference="integrations" alwaysOn allowEmpty>
            <AutocompleteInput allowEmpty={true} translateChoice={false} optionText="name" />
        </ReferenceInput>}

        <ReferenceInput sort={{ field: 'companyName', order: 'ASC' }} label="Company (Customer number)" source="companyId" reference="companies" alwaysOn allowEmpty className="width-220px">
            <AutocompleteInput allowEmpty={true} translateChoice={false} optionText={company => company.companyName === "" ? "" : company.companyName + " (" + company.customerNumber + ")"} />
        </ReferenceInput>

        {showExternalCompanyNumber && <NumberInput source="externalCompanyNumber" min={0} alwaysOn />}

        {showName && <TextInput source="name" alwaysOn allowEmpty />}

        {showEntityTypeId && <SelectArrayInput className="width-60px" label="Type" source="entityType" choices={[
            { id: '1', name: 'Invoice' },
            { id: '2', name: 'Invoice payment' },
            { id: '3', name: 'Invoice balance' },
            { id: '10', name: 'Supplier' },
            { id: '11', name: 'Supplier invoice' },
            { id: '12', name: 'Supplier invoice payment' },
            { id: '13', name: 'Supplier order response' },
            { id: '14', name: 'Supplier dispatch advice' },
            { id: '15', name: 'Supplier Invoice EDI' },
            { id: '16', name: 'Supplier Discount' },
            { id: '17', name: 'Supplier Invoice Picture' },
            { id: '18', name: 'Supplier Categories' },
            { id: '20', name: 'Time, grouped by date and code' },
            { id: '21', name: 'Time, continuous' },
            { id: '22', name: 'Time, grouped by date and code and project' },
            { id: '23', name: 'Time, continuous, with price' },
            { id: '29', name: 'Time, single' },
            { id: '30', name: 'Account' },
            { id: '40', name: 'Cost center' },
            { id: '50', name: 'Item' },
            { id: '51', name: 'Item Price' },
            { id: '60', name: 'Terms of payment' },
            { id: '70', name: 'Customer' },
            { id: '75', name: 'Customer Categories' },
            { id: '80', name: 'Project' },
            { id: '90', name: 'Payment method' },
            { id: '100', name: 'Employee' },
            { id: '110', name: 'Company' },
            { id: '129', name: 'Time, single, with misc' },
            { id: '140', name: 'Time Code' },
            { id: '150', name: 'Contact' },
            { id: '160', name: 'Order' },
            { id: '161', name: 'Order Row' },
            { id: '162', name: 'Order Attachment' },
            { id: '163', name: 'Orderparticipant' },
            { id: '170', name: 'Object' },
            { id: '180', name: 'SIE' },
            { id: '181', name: 'CSV' },
            { id: '190', name: 'External Status' },
            { id: '200', name: 'General Ledger' },
            { id: '201', name: 'General Ledger Row' },
            { id: '210', name: 'Project Phase' },
            { id: '220', name: 'Tracked SFTP' },
            { id: '230', name: 'Payslip' },
            { id: '240', name: 'ImpLevLogg' },
            { id: '241', name: 'ImpLevRad' },
            { id: '242', name: 'Journal Response' },
            { id: '243', name: 'Attestation Response' },
            { id: '244', name: 'Token' },
            { id: '245', name: 'Salary' },
            { id: '246', name: 'FailedEntity' },
            { id: '247', name: 'FailedFtpEntity' },
            { id: '248', name: 'IntegrationExportResponse' },
            { id: '250', name: 'Bid' },
            { id: '260', name: 'IdMapping' },
            { id: '270', name: 'UserAccessRights' },
            { id: '280', name: 'EmployeeTime' },
            { id: '290', name: 'TimeApprovalPeriod' },
            { id: '291', name: 'TimeEntryStatus' },
            { id: '300', name: 'AccountingData' },
            { id: '310', name: 'RaksiReport' },
            { id: '320', name: 'IntegrationEngineAnalyticsReport' }
        ]} alwaysOn allowEmpty />}

        {showIncomplete && <NullableBooleanInput label="Failed" source="incomplete" alwaysOn />}

        {showStatusTypeId && <SelectArrayInput className="width-70px" label="Status" source="statusTypeId" choices={[
            { id: '1', name: 'In progress' },
            { id: '200', name: 'Succeeded' },
            { id: '201', name: 'Succeeded, but has errors' },
            { id: '202', name: 'Succeeded by user' }
        ]} alwaysOn allowEmpty />}

        {showUpdatedAtGte && <DateInput label="Updated after" source="updatedAt_gte" alwaysOn />}

        {showEndpoint && <ReferenceInput filter={!props.filterValues.companyId ? {} : { companyId: props.filterValues.companyId }} sort={{ field: 'endpointName', order: 'ASC' }} label="Endpoint" source="endpointId" reference="endpoints" alwaysOn allowEmpty>
            <AutocompleteInput allowEmpty={true} translateChoice={false} optionText="endpointName" />
        </ReferenceInput>}

        {showModuleConfiguration && <ReferenceInput filter={!props.filterValues.integrationId ? { parentId: null } : { parentId: null, integrationId: props.filterValues.integrationId }} sort={{ field: 'name', order: 'ASC' }} label="Entrypoint" source="entrypointModuleConfigurationId" reference="moduleconfigurations" alwaysOn allowEmpty>
            <AutocompleteInput allowEmpty={true} translateChoice={false} optionText="name" />
        </ReferenceInput>}

        {showDevelopment && <NullableBooleanInput source="development" alwaysOn />}
        {showHasEntities && <NullableBooleanInput source="hasEntities" alwaysOn />}
    </Filter>
    );
};